const NoDataFound = ({
  isFullScreen = true,
  message = "No Data Found",
  subMessage = "There is nothing to display here.",
}) => {
  return (
    <div
      className={`w-full p-5  h-screen inset-0 bg-white flex justify-center items-center`}
    >
      <div className="flex flex-col items-center text-center px-4">
        
        {/* Icon */}
         <div className="w-20 h-20 bg-gray-100 rounded-full mx-auto flex items-center justify-center mb-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-10 w-10 text-gray-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                      />
                    </svg>
                  </div>

        {/* Title */}
        <h2 className="text-lg font-semibold text-gray-700">
          {message}
        </h2>

        {/* Sub text */}
        <p className="text-sm text-gray-500 mt-1">
          {subMessage}
        </p>
      </div>
    </div>
  );
};

export default NoDataFound;